import React, {Component} from 'react';
import {connect} from 'react-redux';

class Aspect extends Component {
  getPadding() {
    if(this.props.aspect) {
      const ex = this.props.aspect.split(":");
      ex[0] = parseInt(ex[0]);
      ex[1] = parseInt(ex[1]);

      return (100 * ex[0] / ex[1]) + '%';
    }
    if(this.props.img) {
      return (100 * this.props.img.height / this.props.img.width) + '%';
    }
  }
  renderChildren() {
    if(this.props.pa) {
      return (
        <div className="pa pa-tl w100 h100">
          {this.props.children}
        </div>
      )
    } else {
      return this.props.children;
    }
  }
  getCurrentRealSize()
  {
    if(this.props.resizedCode) {
      const parts = this.props.resizedCode.split("x");
      if (parts[2]) {
        parts[2] = parts[2].split("-")[0];
      }
      parts[0] = parseInt(parts[0]);
      parts[1] = parseInt(parts[1]);
      if (parts[2] == "C" || parts[2] == "F") {
        return {
          width: parts[0],
          height: parts[1],
          use_cf: true,
        }
      } else {
        if (this.props.img.width <= parts[0] && this.props.img.height <= parts[1]) {
          return {
            width: this.props.img.width,
            height: this.props.img.height,
            smaller: "yes"
          }
        } else {
          //1000 x 2000 => 600x500
          /*
          600/1000 = 0.6
          500/2000 = 0.25
           */
          const widthOtn = parts[0]/this.props.img.width;
          const heightOtn = parts[1]/this.props.img.height;
          let useOtn = widthOtn;
          if (widthOtn > heightOtn) {
            useOtn = heightOtn;
          }
          return {
            width: Math.round(this.props.img.width * useOtn),
            height: Math.round(this.props.img.height * useOtn),
            use_otn: useOtn,
          }
        }
      }
    } else {
      return false;
    }
  }
  componentWillUnmount() {
    if(this._resizeFunc) {
      window.removeEventListener("resize",this._resizeFunc);
    }
  }

  checkSizes(realSize) {
    if(!this._resizeFunc) {
      this._resizeFunc=()=>{
        if(!this._wrapRef) {
          return null;
        }
        if(this._wrapRef.clientWidth<realSize.width) {
          this._wrapRef.style.height='auto';
        } else {
          this._wrapRef.style.height=realSize.height;
        }
      }
    }
    window.addEventListener("resize",this._resizeFunc);
    this._resizeFunc();
  }
  render() {
    const realSize=this.getCurrentRealSize();
    if(realSize) {
      return (
        <div ref={(ref)=>{
          this._wrapRef=ref;
          this.checkSizes(realSize);
        }} style={{width:realSize.width, height:realSize.height, maxWidth:'100%'}} className="ofh center">
          <div className={`pr ${this.props.className?this.props.className:''}`} style={{paddingBottom:this.getPadding()}}>
            {this.renderChildren()}
          </div>
        </div>
      )
    } else {
      return (
        <div className={`pr ${this.props.className?this.props.className:''}`} style={{paddingBottom:this.getPadding()}}>
          {this.renderChildren()}
        </div>
      )
    }
  }
}


export default Aspect;